export default {
  // 模式
  "common.mode.auto": "O'ziga xos ishlab chiqarilgan energiya foydalanishi",
  "common.mode.economy": "Iqtisodiy rejim",
  "common.mode.exigency": "Favqulodda holat rejimi",

  // 设备
  "common.grid": "Elektro tarmogi",
  "common.evChargers": "Elektro avtomobillar uchun zaryadlovchilar",
  "common.evCharger": "Elektro avtomobil uchun zaryadlovchi",
  "common.pv": "Fotovoltaik",
  "common.inverter": "Invertor",
  "common.pcs": "Invertor + batareya",
  "common.terminal": "Terminal qurilmasi",
  "common.airc": "Konditsioner",
  "common.engine": "Dvigatel",
  "common.battery": "Batareya",
  "common.metter": "Elektro hisoblagich",
  "common.other": "Boshqa",
  "common.power": "Quvvat",
  "common.powerTotal": "Jami quvvat",
  "common.voltage": "Voltaj",
  "common.electricity": "Elektroenergiya",
  "common.current": "Tok",
  "common.homeUsage": "Uyning jami yuklanishi",
  "common.battery.power": "Batareya quvvati",

  // 数据
  "common.noDataAvailable": "Hozircha ma'lumotlar mavjud emas~",
  "common.tips": "Ishora",
  "common.reset": "Qayta o'rnatish",
  "common.currencyUnit": "¥",
  "common.submiting": "Yuborilmoqda... Iltimos, kuting...",
  "common.close": "Yopish",
  "common.from": "Dan",
  "common.useIn": "Uchun foydalanish",
  "common.energyPercent": "Energiya oqimining foizi",
  "common.dataFlow": "Ma'lumotlar oqimi",
  "common.getDataIng": "Ma'lumotlar olinmoqda... Iltimos, kuting...",
  "common.pageLoading": "Sahifa kontenti yuklanmoqda... Iltimos, kuting...",
  "common.reseting": "Sahifa kontenti qayta o'rnatilmoqda... Iltimos, kuting...",
  "common.save": "Saqlash",
  "common.onlyNumberTips": "Faqat raqamlar kiriting mumkin",
  "common.offline": "Ofline",
  "common.online": "Onlayn",
  "common.fault": "Xato",
  "common.charge": "Zaryadlash",
  "common.discharge": "Tushirish",
  "common.buy": "Sotib olish",
  "common.sell": "Sotish",
  "common.loadingInfo": "Yuklanmoqda... Iltimos, kuting...",

  // 
  "common.moreFeatures": "Ko'proq xususiyatlar",
  "common.confirm": "Tasdiqlash",
  "common.saveing": "Saqlanmoqda... Iltimos, kuting...",
  "common.searchPlacholder": "Qidiruv uchun kalit so'z kiriting",
  "common.iSee": "Tushundim",
  "common.pageErrorTips1": "Oh, sahifada xato ro'y berdi~",
  "common.pageErrorTips2": "Sahifani yangilang yoki support bilan bog'laning~",
  "common.refresh": "Yangilash",
  "common.backToHome": "Bosh sahifaga qaytish",
  "common.checkTips": "Tekshirilmoqda... Iltimos, kuting...",
  "common.back": "Qaytish",
  "common.cancel": "Bekor qilish",
  "common.optional": "Ixtiyoriy",
  "common.required": "Majburiy",
  "common.status": "Holati",
  "common.statusNoDelete": "O'chirilgan emas",
  "common.statusDelete": "O'chirilgan",
  "common.submit": "Yuborish",
  "common.disable": "O'chirish",
  "common.enable": "Yoqish",
  "common.year": "yil",
  "common.month": "oy",
  "common.day": "kun",
  "common.version": "Versiya:",
  "common.backHome": " Bosh sahifaga qaytish",
  "common.backHomeSorry": " Kechirasiz, sahifa tasodifan yo'qolgan",
  "common.requestTips1": "Ma'lumotlar qayta ishlanmoqda, qayta yubormang",
  "common.requestTips2": "Tizim xabari",
  "common.requestTips3": "Kirish holati tugagan, iltimos qayta kirishingiz",
  "common.requestTips4": "Qayta kirish",
  "common.requestTips5": "Haqiqiy bo'lmagan seans yoki seans tugagan, iltimos qayta kirishingiz.",
  "common.requestTips6": "Server xatosi, iltimos keyinroq qayta urinib koʻring.",
  "common.requestTips7": "Tizim interfeysi so'rovining vaqtini tugagan",
  "common.requestTips8": "Tizim interfeysi",
  "common.requestTips9": "Xato",
  "common.iknow": "Tushundim",
  "common.logoutSuccess": "Chiqish muvaffaqiyatli",
  
  // 了解更多组件
  "common.knowMore.title": "Ko'proq ma'lumot uchun Beineng bilan bog'laning",
  "common.knowMore.email": "Bog'lanish elektron pochtasi",
  "common.knowMore.phone": "Bog'lanish telefon raqami",
  "common.knowMore.wechat": "Bog'lanish WeChat",
  "common.knowMore.website": "Rasmiy veb-sayt manzili",
  "common.knowMore.address": "Bog'lanish manzili",
  "common.knowMore.addressDetail": "Guangdong viloyati, Dongguan shahri, Huangjiang tumani, Huangjingkeng qishlog'i, Qinghe ko'chasi 8-uy, 5-xonadon, 1205 va 1301 xonalar",
  
  // 本地连接组件
  "common.localConnection": "Mahalliy ulanish",
  "common.operateInApp": "Amalni ilova ichida bajarring!",
  
  "common.enbleStaus": "Yoqish holati",
  "common.battery.status": "Zaryadlash va tushirish yo'q",

  "account.forgetThePassword": "Parolni unutdingiz",
  "account.logInDirectly": "To'g'ridan-to'g'ri kirish",
  "account.tips1": "Sahifaga yo'naltirilmoqda... Iltimos, kuting...",
  "account.tips2": "Avval foydalanuvchi shartlarini o'qing va qabul qiling!",
  "account.autoLogin": "Avtomatik kirish",
  "account.userLogin": "Foydalanuvchi kirishi",
  "account.registerTips": "Hali hisobingiz yo'qmi? Ro'yxatdan o'tish uchun shu yerga bosing",
  "account.userEmail": "Foydalanuvchi nomi / elektron pochta",
  "account.userEmailTips": "Foydalanuvchi nomini yoki elektron pochta manzilini kiriting",
  "account.password": "Parol",
  "account.passwordTips": "Parolni kiriting",
  "account.submit": "Yuborish",
  "account.submitTips": "Yuborilmoqda... Iltimos, kuting...",
  "account.otherLoginTips": "Yoki boshqa kirish usulini tanlang",
  "account.userRegistration": "Foydalanuvchi ro'yxatdan o'tishi",
  "account.userName": "Foydalanuvchi nomi",
  "account.userNameTips": "Foydalanuvchi nomini kiriting",
  "account.emailTips1": "Elektron pochta manzilini kiriting",
  "account.emailTips2": "Haqiqiy bo'lmagan elektron pochta format",
  "account.phone": "Telefon raqami",
  "account.phoneTips1": "Telefon raqamini kiriting",
  "account.phoneTips2": "Haqiqiy bo'lmagan telefon raqami",
  "account.phoneTips3": "Telefon raqamini kiriting",
  "account.passwordTips1": "Parolni kiriting (6-30 belgidan iborat)",
  "account.passwordTips2": "Haqiqiy bo'lmagan parol format: parol ingliz harflari, raqamlar, pastki chiziqlar, chiziqlar va nuqtalarni o'z ichiga olishi kerak, uzunligi 6-12 belgidan iborat",
  "account.passwordTips3": "Ikkita kiritilgan parol mos kelmaydi, iltimos tekshiring va qayta kiriting!",
  "account.passwordTips4": "Parolni kiriting: parol ingliz harflari, raqamlar, pastki chiziqlar, chiziqlar va nuqtalarni o'z ichiga olishi kerak",
  "account.passwordTips5": "Parolni tasdiqlash",
  "account.passwordTips6": "Parolni tasdiqlashni kiriting",
  "account.passwordTips7": "Ikkita kiritilgan parol mos kelmaydi, iltimos tekshiring va qayta kiriting!",
  "account.passwordTips8": "Parolni tasdiqlashni kiriting",
  "account.passwordTips9": "Tabriklaymiz, ro'yxatdan o'tish muvaffaqiyatli!",
  "account.passwordTips10": "Sizning foydalanuvchi nomingiz:",
  "account.emailIs": "Elektron pochta:",
  "account.goToLoginPage": "s soniyadan keyin avtomatik ravishda kirish sahifasiga yo'naltiriladi",
  "account.goLogin": "Kirish",
  "account.goRegister": "Ro'yxatdan o'tish",
  "account.loginSuccess": "Kirish muvaffaqiyatli",
  "account.email": "Elektron pochta",
  "account.sologn": "Siz uchun maxsus energiya rejasini sinchkovlik bilan yaratamiz",
  "account.pleaseAgree": "Men o'qib chiqdim va qabul qildim",
  "userAgreement.privacyPolicy": "maxfiylik siyosati",

  "account.code": "Tasdiqlash kodi",
  "account.codeTips": "Tasdiqlash kodini kiriting",
  "account.codeTips2": "Haqiqiy bo'lmagan tasdiqlash kodi",

    "account.inviteCodeTips": "Iltimos, taklif kodini kiriting",
    "account.inviteCodeHint": "Taklif kodini olish uchun o'rnatuvchi yoki texnik xizmat xodimlariga murojaat qiling",
  "account.modifyPasswordByAccount": "Hisob orqali parolni o'zgartirish",
  "account.modifyPasswordByEmail": "Elektron pochta orqali parolni o'zgartirish",
  "account.getPasswordByAccount": "Hisob orqali parolni olish",
  "account.getPasswordByEmail": "Elektron pochta orqali parolni olish",

  "account.sendEmailTips": "Tasdiqlash kodi elektron pochta ga yuborilgan, iltimos tekshiring",
  "account.name": "Hisob nomi",
  "account.newPassword": "Yangi parol",
  "account.confirmNewPassword": "Yangi parolni tasdiqlash",
  "account.nameTips": "Hisob nomini kiriting",
  "account.passwordModifySuccess": "Parol o'zgartirish muvaffaqiyatli",
  "account.emailCode": "Elektron pochta tasdiqlash kodi",
  "account.emailCodeTips": "Elektron pochta tasdiqlash kodini kiriting",
  "account.emailCodeTips2": "Haqiqiy bo'lmagan elektron pochta tasdiqlash kodi",
  "account.emailModifySuccess": "Parol o'zgartirish muvaffaqiyatli",
  "account.passworTips1": "Sizning parolingiz muvaffaqiyatli qayta o'rnatilgan!",
  "account.passwordTips11": "Parolni tasdiqlashni kiriting",
  "account.passwordTips12": "Yangi parolni kiriting",
  "account.nickname": "Foydalanuvchi pseudonimi",
  "account.modifyNickname": "Foydalanuvchi pseudonimini o'zgartirish",
  "account.modifyNicknameSuccess": "Foydalanuvchi pseudonimini o'zgartirish muvaffaqiyatli!",
  "account.nicknameTips": "Foydalanuvchi pseudonimini kiriting",
  "account.nicknameError": "Foydalanuvchi pseudonimini o'zgartirish muvaffaqiyatsiz!",

  "account.login": "Kirish",
  "account.quickRegister": "Tez ro'yxatdan o'tish",
  "account.sendCode": "Kodni yuborish",
  "account.sendTips": "s soniyadan keyin qayta yuborilishi mumkin",
  "account.sendEmailIng": "Elektron pochta yuborilmoqda... Iltimos, kuting...",
  "account.emailNotEmpty": "Elektron pochta manzili bo'sh bo'lmasligi kerak",
  "account.registerAccount": "Hisob ro'yxatdan o'tish",
  "account.registerWelcome": "SusprSafe ro'yxatdan o'tishiga xush kelibsiz",
  "account.usernameLimit": "Foydalanuvchi nomi harf bilan boshlanishi kerak va faqat harflar, raqamlar va pastki chiziqlarni o'z ichiga olishi mumkin, uzunligi 5-15 belgidan iborat",

  "copyright.desc2": "Veb-sayt ro'yxatdan o'tish ma'lumotlari: Guangdong ICP ro'yxatdan o'tish raqami 2021169764",

  "editUserInfo.editUserInformation": "Foydalanuvchi ma'lumotlarini tahrirlash",
  "editUserInfo.modifyUsername": "Foydalanuvchi nomini o'zgartirish",
  "editUserInfo.changePictures": "Profil rasmini o'zgartirish",
  "editUserInfo.savePicturesSuccess": "Foydalanuvchi profil rasmi muvaffaqiyatli saqlangan",
  "editUserInfo.saveError": "Saqlash muvaffaqiyatsiz",
  "editUserInfo.pictureLimit": "Rasm hajmi 2 MB dan kam bo'lishi kerak",
  "editUserInfo.uploadPicture": "Profil rasmini yuklash",
  "editUserInfo.picturePreview": "Oldindan ko'rish",
  
  "editUserInfo.bindPhoneNumber": "Telefon raqamini bog'lash",
  "editUserInfo.bindEmail": "Elektron pochta bog'lash",
  "editUserInfo.changePassword": "Parolni o'zgartirish",

  "editUserInfo.notificationSettings": "Xabarnoma sozlamalari",
  "editUserInfo.editAccount": "Foydalanuvchi hisobi ma'lumotlarini tahrirlash",
  "editUserInfo.waitBingting": "Bog'lanmoqda... Iltimos, kuting...",
  "editUserInfo.collapse": "Yig'ish",
  "editUserInfo.modifyBinding": "Bog'lanishni o'zgartirish",
  
  "editUserInfo.emailAddress": "Elektron pochta manzili",
  "editUserInfo.tips1": "Elektron pochta bog'lanish muvaffaqiyatli",
  "editUserInfo.tips2": "Saqlash muvaffaqiyatsiz",
  "editUserInfo.tips3": "Elektron pochta tasdiqlash kodi yuborilmoqda... Iltimos, kuting...",
  "editUserInfo.tips4": "Tasdiqlash kodi xxxx elektron pochta ga yuborilgan, iltimos tekshiring",
  "editUserInfo.tips5": "Tasdiqlash kodi yuborish muvaffaqiyatsiz!",
  "editUserInfo.tips6": "Telefon raqami allaqachon bog'langan",
  "editUserInfo.tips7": "Elektron pochta allaqachon bog'langan",
  "editUserInfo.emailTips1": "Elektron pochta manzilini kiriting",
  "editUserInfo.emailTips2": "Haqiqiy bo'lmagan elektron pochta format",
  "editUserInfo.emailTips3": "xxxx soniyadan keyin qayta yuborilishi mumkin",
  "editUserInfo.emailTips4": "Kodni yuborish",
  "editUserInfo.emailTips5": "Elektron pochta tasdiqlash kodi bo'sh bo'lmasligi kerak",
  "editUserInfo.emailTips6": "Haqiqiy bo'lmagan elektron pochta tasdiqlash kodi",
  "editUserInfo.emailCode": "Elektron pochta tasdiqlash kodi",
  "editUserInfo.save": "Saqlash",

  "editUserInfo.phoneTips1": "Telefon raqamini bog'lash muvaffaqiyatli",
  "editUserInfo.phoneTips2": "SMS tasdiqlash kodi yuborilmoqda... Iltimos, kuting...",
  "editUserInfo.phoneTips3": "SMS tasdiqlash kodi xxxx telefon raqamiga yuborilgan, iltimos tekshiring",
  "editUserInfo.phoneTips4": "SMS tasdiqlash kodi yuborish muvaffaqiyatsiz!",
  "editUserInfo.phoneTips5": "Telefon raqamini kiriting",
  "editUserInfo.phoneTips6": "Haqiqiy bo'lmagan telefon raqami format",
  "editUserInfo.phoneTips7": "SMS Kodni yuborish",
  "editUserInfo.phoneTips8": "SMS tasdiqlash kodi",
  "editUserInfo.phoneTips9": "SMS tasdiqlash kodi bo'sh bo'lmasligi kerak",
  "editUserInfo.phoneTips10": "Haqiqiy bo'lmagan SMS tasdiqlash kodi",
  "editUserInfo.phone": "Telefon raqami",


  "editUserInfo.noticeTips1": "Xabarnoma sozlamalarini olish muvaffaqiyatsiz!",
  "editUserInfo.noticeTips2": "Xabarnoma sozlamalari muvaffaqiyatli saqlangan!",
  "editUserInfo.noticeTips3": "Batareya darajasi pastligi haqida xabarnoma",
  "editUserInfo.noticeTips4": "Zaryadlovchi zaryadlashni tugatish haqida xabarnoma",
  "editUserInfo.errorNotification": "Xato haqida xabarnoma",
  "editUserInfo.updateNotification": "Yangilash haqida xabarnoma",
  "editUserInfo.monthlyStatisticsNotification": "Oylik statistika haqida xabarnoma",
  "editUserInfo.notificationMethod": "Qabul qilish usuli",

  "editUserInfo.userNameTips1": "Foydalanuvchi nomi muvaffaqiyatli saqlangan",
  "editUserInfo.userNameTips2": "Foydalanuvchi nomini saqlash muvaffaqiyatsiz",
  "editUserInfo.userNameTips3": "Foydalanuvchi nomini kiriting",
  "editUserInfo.userNameTips4": "Haqiqiy bo'lmagan foydalanuvchi nomi format: faqat raqamlar, pastki chiziqlar va ingliz harflarini o'z ichiga olishi kerak",
  "editUserInfo.userNameTips5": "Foydalanuvchi nomini kiriting",
  "editUserInfo.userNameTips6": "Saqlanmoqda... Iltimos, kuting...",
  "editUserInfo.userName": "Foydalanuvchi nomi",

  "editUserInfo.avatorTips": "Profil rasmini o'zgartirish uchun bosing",
  "editUserInfo.verifyCodeTips1": "Olingan tasdiqlash kodini kiriting:",
  "editUserInfo.verifyCodeTips2": "Hisobingizning xavfsizligi uchun asl telefon raqamiga tasdiqlash kodi yuborish uchun pastdagi tugmani bosing:",
  "editUserInfo.verifyCodeTips3": "Kodni yuborish",
  "editUserInfo.verifyCodeTips4": "Asl telefon tasdiqlash muvaffaqiyatli, yangi bog'langan telefon raqamini kiriting",
  "editUserInfo.verifyCodeTips5": "Hisobingizning xavfsizligi uchun asl elektron pochta ga tasdiqlash kodi yuborish uchun pastdagi tugmani bosing:",
  "editUserInfo.verifyCodeTips6": "Asl elektron pochta tasdiqlash muvaffaqiyatli, yangi elektron pochta manzilini kiriting",
  "editUserInfo.verifyCodeTips7": "Eski parol",
  "editUserInfo.verifyCodeTips8": "Avval elektron pochta bog'lang!",
  "editUserInfo.verifyCodeTips9": "Tasdiqlash kodi elektron pochta ga yuborilgan, iltimos tekshiring",
  "editUserInfo.verifyCodeTips10": ", avtomatik ravishda kirish sahifasiga yo'naltiriladi",

  "hems.notice.title": "Xabarnoma sarlavhasi", 
  "hems.notice.content": "Xabarnoma kontenti", 
  "hems.notice.operate": "Amal",
  "hems.notice.noRead": "O'qilmagan",
  "hems.notice.read": "O'qilgan",
  "hems.notice.warning": "Ogohlantirish",
  "hems.notice.error": "Xato",
  "hems.notice.success": "Statistikani hisoblash",
  "hems.notice.sys": "Tizim ma'lumoti",
  "hems.notice.operateSuccess": "Amal muvaffaqiyatli",
  "hems.notice.operateTips": "Amal uchun elementni tanlang",

  // 首页
  "hems.home.selfuseRate": "O'ziga xos foydalanish darajasi",
  "hems.home.percent": "Foiz",
  "hems.home.todayData": "Bugungi ma'lumotlar",
  "hems.home.todayPowerGeneration": "Bugungi energiya ishlab chiqarish",
  "hems.home.salesIncome": "Energiya sotish daromadi",
  "hems.home.saved": "Siz tejab qildingiz",
  "hems.home.reduce": "Uglerod izi kamaytirish",
  "hems.home.tips1": "Hozircha ma'lumotlar mavjud emas, siz hali xxxx bog'langan emassiz",
  "hems.home.criticalLoad": "Kritik yuklanish",
  "hems.home.keyVoltage": "Kritik voltaj",
  "hems.home.householdLoad": "Uy yuklanishi",
  "hems.home.householdVoltage": "Uy voltaji",
  "hems.home.generalLoad": "Oddiy yuklanishi",
  "hems.home.generalVoltage": "Oddiy voltaj",
  "hems.home.batteryHealth": "Batareya salomatligi holati",
  "hems.home.averageTemp": "O'rtacha harorat",
  "hems.home.gridLoad": "Elektro tarmogi yuklanishi",
  "hems.home.toggeleDataSource": "Hozirgi ko'rsatilgan ma'lumotlar o'zgartirilgan:",
  "hems.home.toggleTips": "Iltimos, o'zgartirmoqchi ekanligingizga ishonchingiz komilmi?",
  "hems.home.modeSending": "Rejim buyrug'i yuborilmoqda... Iltimos, kuting...",
  "hems.home.modeSuccess": "Rejim o'zgartirish buyrug'i muvaffaqiyatli yuborilgan!",
  "hems.home.isOnline": "Onlaynmi?",
  "hems.home.useStatus": "Foydalanish holati",
  "hems.home.workModeText": "Hozirgi ishlash rejimi:",
  "hems.home.toggleDataSourceText": "Hozirgi ko'rsatilgan ma'lumotlar o'zgartirilgan:",
  "hems.ev.charge.status": "Zaryadlash holati",
  "hems.ev.charge.time": "Zaryadlash vaqti",
  "hems.ev.charge.count": "Haqiqiy vaqt zaryadlash miqdori",
  "hems.ev.charge.status.empty": "Bo'sh",
  "hems.ev.charge.status.ing": "Kabel bog'langan va zaryadlanmoqda",
  "hems.ev.charge.status.null": "Kabel bog'langan ammo zaryadlanmaydi",
  "hems.ev.charge.status.error": "Xato",
  "hems.hour": "soat",
  "hems.minue": "daqiqa",
  "hems.ev.chagre.number": "Zaryadlovchi raqami",

  // User Guide
  "hems.userGuide.selfUse": "O'ziga xos ishlab chiqarilgan energiya foydalanishi",
  "hems.userGuide.selfUseTips": "Avval fotovoltaik energiyadan foydalaning, agar etarli bo'lmasa, elektro tarmog'idan to'ldiring",
  "hems.userGuide.economyMode": "Iqtisodiy rejim",
  "hems.userGuide.economyModeTips": "Elektroenergiya narxi asosida energiya foydalanish strategiyasini optimallashtirish",
  "hems.userGuide.emergencyMode": "Favqulodda holat rejimi",
  "hems.userGuide.emergencyModeTips": "Avval kritik yuklanishning energiya ta'minotini ta'minlang",

  // 图表页面
  "hems.history.energyStatistics": "Energiya statistikasi",
  "hems.history.revenueStatistics": "Daromad statistikasi",
  "hems.history.greenStatistics": "Yashil emissiya kamaytirish",
  "hems.history.revenueTitle": "Energiya sotishining jami daromadi",
  "hems.history.savingsTitle": "Jami tejamkorlik",
  "hems.history.carbonTitle": "Uglerod emissiyalarini jami kamaytirish",
  "hems.history.day": "kun",
  "hems.history.month": "oy",
  "hems.history.year": "yil",
  "hems.history.beforeDay": "Oldingi kun",
  "hems.history.afterDay": "Keyingi kun",
  "hems.history.beforeMonth": "Oldingi oy",
  "hems.history.afterMonth": "Keyingi oy",
  "hems.history.beforeYear": "Oldingi yil",
  "hems.history.afterYear": "Keyingi yil",
  "hems.history.totalUse": "Jami foydalanish",
  "hems.history.fullScreen": "To'liq ekran",
  "hems.history.timeSelect": "Sana tanlash",
  "sync.tips1": "Ma'lumotlar sinxronizatsiyasi buyrug'i muvaffaqiyatli yuborilgan!",
  "sync.tips2": "Ma'lumotlar sinxronizatsiyasi amalga oshirilmoqda, ma'lumotlar hajmi tufayli vaqt kerak, yarim soatdan keyin qayta tekshiring~",
  "sync.tips3": "Qurilma ma'lumotlari sinxronizatsiyasida kechikish bo'lishi mumkin, agar ma'lumotlarda nomuvofiqlik topilsa, shu yerga bosing:",
  "sync.tips4": "Ma'lumotlarni sinxronizatsiya qilish",

  "charge.info": "Zaryadlovchi ma'lumotlari",
  "news.loading": "Yuklanmoqda...",
  "news.noMore": "Ko'proq ma'lumotlar mavjud emas",
  "hems.pv.power": "Fotovoltaik energiya miqdori",

  // UEH specific
  "ueh.sellPower": "Sotilgan energiya miqdori",
  
  "menu.home": "Bosh sahifa",
  "menu.history": "Tarixiy ma'lumotlar",
  "menu.device": "Qurilmalar",
  "menu.settings": "Sozlamalar",
  "menu.messageCenter": "Xabarnoma markazi",
  "menu.help": "Yordam va support",
  "menu.mine": "Mening",


  "mine.userSetting": "Foydalanuvchi sozlamalari",
  "mine.terminalSetting": "Terminal asosiy sozlamalari",
  "mine.uploadCloud": "Ma'lumotlarni bulutga yuklash",
  "mine.changeVersion": "Yangilashni tekshirish",
  "mine.language": "Tilni o'zgartirish",
  "mine.about": "Ilova haqida",
  "mine.feedback": "Fikr-mulohazalar",
  "mine.logout": "Chiqish",
  "mine.logoutAccount": "Hisobni o'chirish",

  "mine.logoutAccountTips": "[ ] nomli hisobni o'chirish",
  "mine.logoutAccountTips1": "[ ] bilan bog'langan hisobni o'chirish",
  "mine.logoutAccountCare": "Hisobni o'chirish so'rovi bilan bog'liq maslahatlar:",
  "mine.logoutAccountCare1": "1. Hisob xavfsiz holatda",
  "mine.logoutAccountCare1-1": "Hisob oddiy foydalanish holatida, o'g'irlash, qonun buzish yoki bloklash xavfi yo'q.",
  "mine.logoutAccountCare2": "2. Hisob ruxsatlari va bog'lanishlari olib tashlangan",
  "mine.logoutAccountCare2-1": "Hisobning boshqa uchinchi tomon platformalari bilan barcha ruxsatlari olib tashlangan.",
  "mine.logoutAccountCare3": "3. Hisob o'chirilgandan keyin uni qayta tiklash mumkin emas, foydalanuvchi ma'lumotlari o'chiriladi",
  "mine.logoutAccountCare3-1": "Hisob o'chirilgandan keyin, bog'langan telefon raqami, elektron pochta va boshqa ma'lumotlar o'chiriladi va ularni qayta tiklash mumkin emas.",
  "mine.confirmLogout": "O'chirishni tasdiqlash",
  "mine.logoutSuccess": "Hisob muvaffaqiyatli o'chirildi!",


  "mine.feedbackIssues": "Muammolar haqida fikr-mulohazalar",
  "mine.feedQuantity": "Miqdor",
  "mine.feedAmount": "Maksimal 9 rasm, maksimal hajmi 1 MB/rasm",

  "mine.notice.fail": "Xabarnoma sozlamalarini olish muvaffaqiyatsiz!",
  "mine.notice.saveSuccess": "Xabarnoma sozlamalari muvaffaqiyatli saqlangan!",
  "mine.notice.saveFail": "Saqlash muvaffaqiyatsiz!",
  "mine.notice.title": "Xabarnoma sozlamalari",
  "mine.notice.batteryLow": "Batareya darajasi pastligi haqida xabarnoma",
  "mine.notice.chargingFinish": "Zaryadlovchi zaryadlashni tugatish haqida xabarnoma",
  "mine.notice.error": "Xato haqida xabarnoma",
  "mine.notice.update": "Yangilash haqida xabarnoma",
  "mine.notice.monthly": "Oylik statistika haqida xabarnoma",
  "mine.notice.receiveType": "Qabul qilish usuli",

  "mine.language.welcome": "SusprSafe ga xush kelibsiz",
  "mine.language.desc1": "Yashash joyingizga asoslanib til versiyasini tanlang",
  "mine.language.desc2": "Siz uni ilova sozlamalarida har qanday vaqtda o'zgartirishingiz mumkin",

  "mine.userInfo.avatar": "Profil rasmi",
  "mine.userInfo.nickname": "Pseudonim",
  "mine.userInfo.password": "Parol",
  "mine.userInfo.changePassword": "Parolni o'zgartirish",
  "mine.userInfo.setPassword": "Parolni o'rnatish",
  "mine.userInfo.phoneNumber": "Telefon raqami",
  "mine.userInfo.bindPhone": "Telefon raqamini bog'lash",
  "mine.userInfo.bindEmail": "Elektron pochta bog'lash",
  "mine.loginExpired": "Kirish holati tugagan, iltimos qayta kirishingiz",
  "mine.userInfo.title": "Foydalanuvchi ma'lumotlari",
  "mine.userInfo.bind": "Bog'lash",
  "mine.userInfo.modify": "Tahrirlash",
  "mine.userInfo.modifyNickname": "Pseudonimni o'zgartirish",
  "mine.userInfo.userNickname": "Foydalanuvchi pseudonimi",
  "mine.userInfo.selectPic": "Yuklash uchun rasim tanlang",
  "mine.userInfo.saveSuccess": "Saqlash muvaffaqiyatli",
  "mine.userInfo.uploadFail": "Yuklash muvaffaqiyatsiz",
  "mine.userInfo.avatarSaveSuccess": "Profil rasmi muvaffaqiyatli saqlangan",
  "mine.userInfo.nameTips1": "Foydalanuvchi pseudonimi bo'sh bo'lmasligi kerak",
  "mine.userInfo.nameTips2": "Foydalanuvchi pseudonimini kiriting",

  "common.pleaseSelect": "Iltimos, tanlang",
  "question.commonQuestions": "Tez-tez beriladigan savollar",
  "account.toggleLanguage": "Tilni o'zgartirish",
  "account.localConnection": "Mahalliy ulanish",
  "account.selectLanguage": "Iltimos, tilni tanlang",
  "account.sendEmailToast": "Tasdiqlash kodi xxx elektron pochta ga yuborilgan, iltimos tekshiring",
  "account.emailError": "Haqiqiy bo'lmagan elektron pochta format",
  "account.sendEmailFail": "Yuborish muvaffaqiyatsiz, iltimos qayta urining",
  
  "common.submitting": "Yuborilmoqda... Iltimos, kuting...",

  "device.page.noData": "Hozircha ma'lumotlar mavjud emas, ushbu sahifani faqat ilova ichida ko'rishingiz mumkin"
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};